import {
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";

@Component({
  selector: "app-restart-process-button",
  templateUrl: "./restart-button.component.html",
  styleUrls: ["./restart-button.component.scss"],
})
export class RestartButtonComponent
{
  @Input() sameOwner: boolean;
  @Input() isAccountSelected: boolean;
  @Input() identifier: string;
  @Input() label: string;
  @Output() recoverProcessEvent: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  emitRecoverProcessEvent(clicked: boolean) {
    this.recoverProcessEvent.emit(clicked);
  }
}
